import React, { useEffect, useState } from 'react';
import Icons, { Size } from '../Common/Icons';
import { MastheadBrand, Button, ButtonVariant, StackItem, Stack, Split, SplitItem } from '@patternfly/react-core';

import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { UserMenu } from './UserMenu';
import { SideBar } from './SideBar';
import { useTabletOrMobile } from '../../utils/hooks/useTabletOrMobile';
import { SignInButton } from './SignInButton';

import './Navbar.css';

const storeExpansionState = true;
const expansionStateStorageName = 'sideBarExpanded';

export const DrawerContext = React.createContext({
  isDrawerOpen: false,
  setIsDrawerOpen: () => {}
});


const SignIn = ({ inProgress, isAuthenticated }) => {
  if (isAuthenticated) {
    return <UserMenu />;
  } else if (inProgress !== InteractionStatus.Startup && inProgress !== InteractionStatus.HandleRedirect) {
    return <SignInButton />;
  }
  return null;
};


const NavBar = ({ sideBarCollapseCallback, menu, children }) => {
  const [isSideBarCollapsed, setSideBarCollapse] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const isTabletOrMobile = useTabletOrMobile();
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (isTabletOrMobile) {
      localStorage.setItem(expansionStateStorageName, 'false');
    }
    if (storeExpansionState) {
      const storedExpansionState =
        localStorage.getItem(expansionStateStorageName) === 'true';
      setSideBarCollapse(storedExpansionState);

      if (sideBarCollapseCallback) {
        sideBarCollapseCallback(storedExpansionState);
      }
    }

  }, [isTabletOrMobile, sideBarCollapseCallback]);

  const toggleSideBar = () => {
    const willBeExpanded = !isSideBarCollapsed;
    setSideBarCollapse(willBeExpanded);

    if (storeExpansionState) {
      localStorage.setItem(expansionStateStorageName, willBeExpanded);
    }

    if (sideBarCollapseCallback) {
      sideBarCollapseCallback(willBeExpanded);
    }
  };

  return (
    <DrawerContext.Provider value={{ isDrawerOpen, setIsDrawerOpen }}>
      <Stack>
        <StackItem>
          <div className="nav-item">
            <div>
              <Button
                variant={ButtonVariant.plain}
                onClick={toggleSideBar}
                aria-label="Global navigation"
              >
                <Icons.NavHamburger className="light-icon" size={Size.MEDIUM}/>
              </Button>
              <MastheadBrand component="a">
                <img
                  className="brand-img"
                  src={'/images/logo-small.png'}
                  alt="Beacon Tower"
                />
              </MastheadBrand>
            </div>
            <div>
              <SignIn inProgress={inProgress} isAuthenticated={isAuthenticated}/>
            </div>
          </div>
        </StackItem>
        <StackItem isFilled className={'navbar-content'}>
          <Split className={'split'}>
            <SplitItem>
              <SideBar
                menu={menu}
                toggleSideBar={toggleSideBar}
                isSideBarCollapsed={isSideBarCollapsed}
              />
            </SplitItem>
            <SplitItem isFilled style={{ width: '100%' }}>
              { children }
            </SplitItem>
          </Split>
        </StackItem>
      </Stack>
    </DrawerContext.Provider>
  );
};

export default NavBar;
